import React from 'react';
import SignUpForm from '../../../components/Forms/signup';

import promoHeader from './images/readers_in_hand-crunch.png'

import styles from './signup.module.scss';

const bgStyles = {

  marginTop:'67px'
}

function checkForTest(props) {
  const abTest = props.abTest ? styles.abTest : '';
  return abTest;
}

const IndexPage = (props) => (
  <div>
    <span className={styles.anchor} id="signupPromo" />
    <section style={props.style}  className={`${checkForTest(props)} ${styles.signupHeader}` }>
      <div className="container marketingSection" style={bgStyles}>
        <div className="row" style={{flexDirection: 'row-reverse'}}>
          <div className={styles.mobileHidden}>
            <h3 style={{color: '#00537C'}}>Sell more this winter.</h3>
            <p style={{color: '#00537C'}}>Start today with R250 off any Yoco card reader. <br /> Offer valid 21 - 30 June. While stocks last. </p>
          </div>
          <div className="col-md-5 text-center center-content" >
            <div style={{maxWidth:370, backgroundColor: '#fff', padding:40, borderRadius:0}}>
              <h2>Sign up</h2>
              <h3>Let's get you started</h3>
              <SignUpForm
                CTA="Purchase card reader"
                track="[signup] promo wireless lite"
              />
            </div>
          </div>
          <div className={`col-md-7  pt-3 pb-0  center-content ${styles.promoHeader}`}   >
            <div>
              <h3 style={{color: '#00537C'}}>Sell more this winter.</h3>
              <p style={{color: '#00537C'}}>Start today with R250 off any Yoco card reader. <br /> Offer valid 21 - 30 June. While stocks last. </p>
              <img src={promoHeader} />
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
)

export default IndexPage


// WEBPACK FOOTER //
// ./src/sections/promos/signupHeader/index.js